const getters = {
    getNumberNo: state => state.app.numberNo,
    getNameCar: state => state.app.nameCar
};
export default getters;
